import { animate, group, query, style, transition, trigger } from '@angular/animations';

const LeftToRight = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%', zIndex: '4' }), { optional: true }),
  group([
    query(':enter', [
      style({ transform: 'translateX(-100%)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(0%)' }))
    ], { optional: true }),
    query(':leave', [
      style({ transform: 'translateX(0%)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(100%)' }))
    ], { optional: true }),
  ])
];

const RightToLeft = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%', zIndex: '4' }), { optional: true }),
  group([
    query(':enter', [
      style({ transform: 'translateX(100%)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(0%)' }))
    ], { optional: true }),
    query(':leave', [
      style({ transform: 'translateX(0%)' }),
      animate('300ms ease-in-out', style({ transform: 'translateX(-100%)' }))
    ], { optional: true }),
  ])
];

const triggers = [
  // LEFT TO RIGHT AKA RESET
  transition('* => 0', LeftToRight),
  // LEFT TO RIGHT AKA PREVIOUS
  transition('* => 1', LeftToRight),
  // RIGHT TO LEFT AKA NEXT
  transition('* => 2', RightToLeft)
];

export const Transitions = [
  trigger('transition', triggers)
];

export enum RoutingLevel {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7,
  Eight = 8,
  Nine = 9,
  Ten = 10,
}
